// extracted by mini-css-extract-plugin
export default {"collage":"ImageCollage_collage__-WLEx"};